import type { Session } from '$lib/auth/types';
import type { LayoutLoad } from './$types';
import { browser } from '$app/environment';
import { GetMeStore } from '$houdini';
import { getAuthStore } from '$lib/auth/store';
import { initAds } from '$lib/services/advertising';
import { setUserId } from '$lib/services/tracking/googleAnalytics';
import { getPlatform } from '$lib/utils/getPlatform';
import { get } from 'svelte/store';

export const load = (async (event) => {
	// not a real url, we use it to be able to invalidate after userStore changed login state
	event.depends('app:login');
	event.depends('loadUser:init');
	const authStore = getAuthStore();
	let userProfileStore: GetMeStore | undefined;
	let userSession: Session | null = null;

	if (browser) {
		initAds(event.data.locale);
		userSession = await authStore?.refreshSession();

		if (userSession) {
			setUserId(userSession.user.id);

			userProfileStore ??= new GetMeStore();

			await userProfileStore.fetch({
				event,
				policy: 'NetworkOnly',
			})
				.catch((error) => {
					if (userProfileStore) {
						get(userProfileStore);
					}
					throw error;
				});
		}
	}

	return {
		...event.data,
		userSession,
		userProfileStore,
		browserPlatform: browser ? getPlatform() : undefined,
	};
}) satisfies LayoutLoad;
